if (!customElements.get("cart-progress-step-gift")) {
  customElements.define(
    "cart-progress-step-gift",
    class CartProgressStepGift extends HTMLElement {
      cartTotalPrice = 0;

      constructor() {
        super();
        this.themeCurrency = themeVendor.themeCurrency;

        this.jsonData = null;
        try {
          this.jsonData = JSON.parse(this.querySelector('[data-cart-step-json]')?.innerHTML.replaceAll('\n', '').replace('},]', '}]'));
        } catch (error) {
          console.error(error);
        }

        if (!this.jsonData) return;

        this.rate = window.Shopify.currency.rate;
        for (const step of this.jsonData.steps) {
          step.minimum_price = step.minimum_price * this.rate;
        }
        this.progressHeight = 10;
        this.findElements();
        this.init();
      }

      findElements() {
        this.progress = this.querySelector("[data-step-progress]");
        this.progressAchieve = this.querySelector("[data-step-progress-achieve]");
        this.stepItems = this.querySelectorAll("[data-step-item]");
        this.messageElement1 = this.closest('[data-drawer]').querySelector("[data-step-message-1]");
        this.messageElement2 = this.closest('[data-drawer]').querySelector("[data-step-message-2]");
      }

      init() {
        this.listen();
      }

      listen() {
        document.addEventListener(
          "theme:cart:change",
          function (event) {
            this.cart = event.detail.cart;
            this.cartTotalPrice = this.getCartPriceNoGift(event.detail.cart);
            this.render();
          }.bind(this)
        );
        document.addEventListener(
          "theme:cart:update",
          function (event) {
            this.cart = event.detail.cart;
            this.cartTotalPrice = this.getCartPriceNoGift(event.detail.cart);
            this.render();
          }.bind(this)
        );
      }

      render() {
        const progressSteps = this.jsonData.steps;
        // 当前购物车符合条件的 Progress step
        let currentProgressStepIndex = -1;
        let currentProgressStep = undefined;
        for (let i = 0; i < progressSteps.length; i++) {
          const progressStep = progressSteps[i];
          if (progressStep.minimum_price <= this.cartTotalPrice && (currentProgressStep == undefined || currentProgressStep.minimum_price < progressStep.minimum_price)) {
            currentProgressStep = progressStep;
            currentProgressStepIndex = i;
          } else {
            break;
          }
        }
        // 下一个步骤
        const nextStep = currentProgressStepIndex >= (progressSteps.length - 1) ? null : progressSteps[currentProgressStepIndex + 1];

        this.updateMessage(currentProgressStep, nextStep, currentProgressStepIndex);
        this.updateProgress(currentProgressStep, nextStep, currentProgressStepIndex);
        this.updateStepItems(currentProgressStep, currentProgressStepIndex);

        for (const element of this.querySelectorAll('[data-money]')) {
          const money = Number(element.getAttribute('data-money')) * this.rate;
          if (!isNaN(money)) {
            let moneyFormat = money % 100 == 0 ? this.formatMoney(money).toString().slice(0, -3) : this.formatMoney(money);
            element.innerHTML = moneyFormat;
          }
        }
      }

      // 更新提示语句
      updateMessage(currentStep, nextStep, currentStepIndex) {
        if (!this.messageElement1 || !this.messageElement2) {
          this.findElements();
        }
        // console.log('currentStepIndex:', currentStepIndex, 'currentStep: ', currentStep, 'nextStep: ', nextStep);

        if (!currentStep) {
          // 什么都没满足
          const spendMoreMoney = nextStep ? (nextStep.minimum_price - this.cartTotalPrice) : 0;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = nextStep.before_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = '';
        } else if (!nextStep) {
          // 全都满足
          const spendMoreMoney = 0;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = currentStep.after_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = '';
        }
        else {
          // 部分满足
          const spendMoreMoney = nextStep ? (nextStep.minimum_price - this.cartTotalPrice) : 0;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = currentStep.after_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = nextStep.before_message.replace("||amount||", this.formatMoney(spendMoreMoney));
        }
      }

      // 更新进度条
      updateProgress(currentStep, nextStep, currentStepIndex) {

        const progressBounding = this.progress.getBoundingClientRect();
        const maxWidth = progressBounding.width;
        if (maxWidth <= 0) return;


        let progress = 0;
        if (currentStepIndex < 0) {
          // 什么都没满足
          let progressPx = 0;
          // 超出的部分
          const offsetPriceRate = this.cartTotalPrice / nextStep.minimum_price;

          // 增加下一个条件的已满足部分的偏移量
          const nextStepItem = this.stepItems[currentStepIndex + 1];
          progressPx += nextStepItem ? (nextStepItem?.offsetLeft ?? 0) * offsetPriceRate : 0;

          progress = progressPx * 100 / maxWidth;
        } else if (currentStepIndex >= this.stepItems.length - 1) {
          // 全都满足
          progress = 100;
        } else {
          // 部分满足
          const currentStepItem = this.stepItems[currentStepIndex];
          const currentStepItemOffsetLeft = currentStepItem?.offsetLeft ?? 0;
          const currentStepItemOffsetRight = currentStepItemOffsetLeft + currentStepItem.getBoundingClientRect().width;
          const nextStepItem = this.stepItems[currentStepIndex + 1];
          const nextStepItemOffsetLeft = nextStepItem?.offsetLeft ?? 0;
          // 超出的部分
          const offsetPriceRate = (this.cartTotalPrice - currentStep.minimum_price) / (nextStep.minimum_price - currentStep.minimum_price);

          // 增加已满足条件的偏移量
          let progressPx = currentStepItem ? (currentStepItemOffsetRight) : 0;
          // 增加下一个条件的已满足部分的偏移量
          progressPx += nextStepItem ? (nextStepItemOffsetLeft - currentStepItemOffsetRight) * offsetPriceRate : 0;

          progress = progressPx * 100 / maxWidth;
        }

        if (this.progress != null && this.progressAchieve != null) {
          this.progressAchieve.style.width = progress + "%";
        }
      }

      // 更新步骤
      updateStepItems(currentStep, currentStepIndex) {
        // 激活指定步骤
        if (currentStepIndex < 0 || currentStep == undefined) {
          for (const stepItem of this.stepItems) {
            stepItem.classList.remove('active');
          }
        } else {
          for (let i = 0; i < this.stepItems.length; i++) {
            const stepItem = this.stepItems[i];
            i <= currentStepIndex
              ? stepItem.classList.add('active')
              : stepItem.classList.remove('active');
          }
        }
      }

      /**
       * 计算排除了 Gift 后的购物车总价
       */
      getCartPriceNoGift(cart) {
        if (!cart || cart?.items?.length == 0) return 0;
        // 赠品产品id列表
        const giftProductIdList = window.cartGiftSettings.all_gift_product_ids;
        /** 除开赠品后的购物车总价（无小数位形式, 含汇率） */
        let cartPriceNoGift = cart.items_subtotal_price;

        // 计算除开赠品后的购物车总价
        for (let index = 0; index < cart.items.length; index++) {
          const cartItem = cart.items[index];
          if (giftProductIdList.includes(cartItem.product_id)) {
            cartPriceNoGift -= cartItem.final_line_price;
          }
        }
        return cartPriceNoGift;
      }

      formatMoney(integerPrice) {
        return themeVendor.themeCurrency.formatMoney(integerPrice, theme.moneyFormat)?.replace('.00', '');
      }
    }
  );
}
